//import "./css/dataTables.responsive.css";
// import "./css/dataTables.tableTools.min.css";
import "./css/dataTables.bootstrap.css";

import "./jquery.dataTables.js";
import "./dataTables.responsive.js";
// import "./dataTables.tableTools.min.js";
import "./dataTables.bootstrap.js";



// WEBPACK FOOTER //
// ./src/lib/dataTables/index.js